export default [{
    name: "Coffee Shop (BF)<br/>豪生咖啡厅（早餐）",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 0,
}, {
    name: "Coffee Shop (L&D)<br/>豪生咖啡厅（午晚餐）",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 1,
}, {
    name: "Chinese Restaurant<br/>中餐厅",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 2,
}, {
    name: "Special Restaurant<br/>特色餐厅",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 3,
}, {
    name: "Lobby Lounge<br/>大堂酒吧",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 4,
}, {
    name: "Room Service<br/>送餐服务",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 5,
}, {
    name: "Banquet<br/>宴会厅",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 6,
}, {
    name: "Mini Bar<br/>迷你吧",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 7,
}, {
    name: "Executive Club<br/>行政楼层",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 8,
}, {
    name: "Other Income<br/>其他收入",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 9,
}, {
    name: "Total F&B Revenue<br/>餐饮合计",
    actual: 0,
    covers: 0,
    average: 0,
    last_actual: 0,
    last_covers: 0,
    last_average: 0,
    sort: 10,
}]


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/Food/data.js